export default __webpack_public_path__ + "static/media/logo.5f8fd90f.png";